import { FavoriteType, Product } from 'src/types/schema/graphql'
import * as UI from '@brewlogix/blx-ui'
import Image from 'next/image'
import getDefaultIconByProduct from 'src/util/helpers/getDefaultIconByProduct'
import { FavoritesButton, LegacyFavoritesButton } from 'src/features/favorites/components'
import FeaturedBrewLocationRelationshipPills from './FeaturedBrewLocationRelationshipPills'

interface IFeaturedBrew {
    featuredBrew: Product
    locationId: string
}

const FeaturedBrewCard: React.FC<IFeaturedBrew> = ({ featuredBrew, locationId }) => {
    const defaultIcon = getDefaultIconByProduct(featuredBrew)

    return (
        <div className='space-y-6'>
            <UI.Heading
                text='Featured Brew'
                size='h4'
                type='h2'
                customClasses='text-xl lg:text-2xl'
            />
            <UI.Card>
                <div className='flex w-full flex-row'>
                    <div className='relative mr-4 h-28 w-28 flex-shrink-0 rounded-md border-px border-gray-100'>
                        {featuredBrew?.assets?.length > 0 ? (
                            <UI.Media
                                asset={featuredBrew?.assets[0]}
                                customWrapperClasses='bg-gray-100 rounded-md'
                                width={300}
                                height={300}
                                alt={`Logo Image for ${featuredBrew?.title}`}
                            />
                        ) : (
                            <div className='rounded-lg'>
                                <Image
                                    src={defaultIcon}
                                    alt={`Default ${featuredBrew} Icon`}
                                    width={300}
                                    height={300}
                                />
                            </div>
                        )}
                    </div>
                    <div className='flex w-full flex-col space-y-1'>
                        <div className=' flex w-full flex-row justify-between'>
                            <UI.Heading size='h6'>{featuredBrew?.title}</UI.Heading>
                        </div>
                        <div className='flex flex-col items-start gap-2'>
                            <span className='inline font-bold text-gray-400'>
                                {featuredBrew?.style?.title} -{featuredBrew?.abv}%
                            </span>
                        </div>
                        {/* // TODO: When featureBrew is on a Location istead of a Brand, add these pills */}
                        {/* <FeaturedBrewLocationRelationshipPills featuredBrew={featuredBrew} locationId={locationId} /> */}
                    </div>
                    <div className='relative flex h-full min-h-full flex-col items-end justify-between'>
                        <LegacyFavoritesButton
                            type={FavoriteType.Product}
                            heartSize='md'
                            ariaLabel={`Add ${featuredBrew?.title} to Your Favorites`}
                            item={featuredBrew}
                        />
                    </div>
                </div>
            </UI.Card>
        </div>
    )
}

export default FeaturedBrewCard
